import { axiosInstance } from '../api/axiosInstance';
import { backendBaseUrl } from './platformBasedInfo';
import { readVisitorId, touchSessionId } from './attribution';

type RecordEventBody = {
  eventName: string;
  system: 'SEGMENT' | 'CUSTOMER_IO' | 'INTERNAL';
  source: 'APPLY' | 'VOLT' | 'BACKEND';
  properties?: Record<string, unknown>;
  accountPublicId?: string;
  opportunityPublicId?: string;
  contactPublicId?: string;
  leadPublicId?: string;
  partnerPublicId?: string;
  filePublicId?: string;
  anonymousId?: string;
  sessionId?: string;
};

/**
 * Fire-and-forget POST to /v1/events/record.
 * Only fires when the user has an auth token (post-login steps).
 * Errors are swallowed so analytics never impacts the main flow.
 */
export function recordApplyEvent(
  eventName: string,
  properties?: Record<string, unknown>,
  opts?: {
    accountPublicId?: string;
    opportunityPublicId?: string;
    contactPublicId?: string;
    leadPublicId?: string;
  }
): void {
  try {
    // Only record if we have auth — axiosInstance has the token set
    // by the useAxios hook when user is logged in
    const token = axiosInstance.defaults.headers.common['Authorization'];
    if (!token) return;

    // The first-party visitor id and rolling session id ride on every row —
    // before 2026-09-09 Apply events never carried either, so an applicant
    // tracked anonymously on tento.com/Volt became a second identity here.
    const body: RecordEventBody = {
      eventName,
      system: 'SEGMENT',
      source: 'APPLY',
      properties,
      anonymousId: readVisitorId() ?? undefined,
      sessionId: touchSessionId() ?? undefined,
      ...opts,
    };

    axiosInstance.post(`${backendBaseUrl}/v1/events/record`, body).catch(() => {
      // analytics — no impact to main flow
    });
  } catch {
    // analytics — no impact to main flow
  }
}
